const ar = {
  onboarding: {
    countryQuestion: "فهمت! 🌍\n\nفي أي بلد أنت؟",
    countryPlaceholder: "في أي بلد أنت؟",
    letsGo: "لنبدأ!",
    summaryIntro: "🎉 رائع، {name}! كل شيء جاهز!",
    yourNameLabel: "اسمك",
    baseLanguageLabel: "اللغة الأساسية",
    goalsHint: "يمكنك ضبط هدف المفردات ومدة الدورة في أي وقت من صفحة الأهداف.",
    startLearning: "ابدأ تعلم {destLang}!",
  },
  header: {
    learner: "متعلم",
    home: "🏠 الرئيسية",
    allLessons: "📚 جميع الدروس",
    currentLesson: "📖 الدرس الحالي",
    flashcards: "🃏 البطاقات التعليمية",
    progress: "📈 التقدم",
    goals: "🎯 الأهداف",
    grammarLab: "📘 القواعد",
    more: "⋯ المزيد",
    myVocabulary: "📝 مفرداتي",
    listenSpeak: "🎧 استمع وتحدث",
    signOut: "↩ تسجيل الخروج",
  },
  lab: {
    title: "مختبر الاستماع والتحدث",
    back: "رجوع",
    intro: "أجرِ محادثة صوتية قصيرة مع بابي حول موضوع درسته من قبل.",
    pickTopic: "اختر موضوعًا أنهيته",
    noTopics: "أكمل درسًا أولاً، ثم عد إلى هنا للتدرب على التحدث.",
    level: "المستوى {level}",
    talkAbout: "تحدث مع بابي عن «{topic}»",
    speedLabel: "سرعة بابي",
    speedNormal: "عادية",
    speedSlow: "بطيئة",
    speedNote: "السرعة البطيئة تستهلك دقائق صوت أكثر لنفس الرد.",
    startConversation: "ابدأ المحادثة",
    tapToStart: "اضغط على الميكروفون وردّ على بابي بالتركية.",
    continueConversation: "أجب عن السؤال",
    finishSession: "إنهاء",
    voiceReviewHint: "راجع ما قلته ثم أكِّده — أو أعد المحاولة.",
    voiceConfirm: "تأكيد",
    voiceRedo: "إعادة",
    voiceDenied: "الصوت غير متاح بدون إذن الوصول إلى الميكروفون. اضغط على أيقونة الميكروفون في أي وقت لإعادة المحاولة.",
    lowBalanceWarning: "أوشكت دقائق الصوت الخاصة بك على النفاد لهذه الدورة الشهرية.",
    thinking: "بابي تفكر…",
    complete: "انتهت الجلسة",
    completeSub: "تدريب جيد. عد في أي وقت للتحدث عن موضوع آخر.",
    another: "تدرب على موضوع آخر",
    done: "تم",
    replyError: "لم تتمكن بابي من الرد الآن. يرجى المحاولة مرة أخرى بعد لحظات.",
    tryAgain: "حاول مرة أخرى",
    eliteUpsellTitle: "الاستماع والتحدث ميزة Elite",
    eliteUpsellBody: "أنت على خطة Pro. قم بالترقية إلى Elite من الإعدادات للتدرب على التحدث مع بابي.",
    listenAgainButton: "استمع مرة أخرى",
    listenAgainPlaying: "إيقاف",
    translateButton: "ترجمة",
    translating: "جارٍ الترجمة…",
    translateFailed: "تعذّرت الترجمة — حاول مرة أخرى.",
    starsAriaLabel: "{stars} من 3",
    explainButton: "توضيح أكثر",
    explaining: "جارٍ التوضيح…",
    explainFailed: "تعذّر الحصول على توضيح — حاول مرة أخرى.",
    recapHeading: "تقرير المحادثة",
    recapTitle: "ملخصك",
    recapAvgStars: "المتوسط في هذه الجلسة",
    recapTurnsCompleted: "أكملت {completed} من {total} جولات",
    recapErrorFree: "{n} جولات بلا أخطاء",
    recapMistakesByType: "الأخطاء حسب النوع",
    recapCorrections: "ما تم تصحيحه",
    voiceMinutesTitle: "دقائق المحادثة الصوتية",
    voiceMinutesLeft: "{amount} من {total} متبقية في هذه الدورة",
    voiceMinutesNone: "لا دقائق شهرية متبقية في هذه الدورة",
  },
  dashboard: {
    greeting: "مرحباً، {name}! 👋",
    streakMsg: "سلسلة {streak} أيام 🔥 — واصل!",
    noStreak: "ابدأ درسك الأول اليوم!",
    streakProtectionDays: "{n} يوم من أيام حماية السلسلة مكتسبة 🛡️",
    dayInfo: "اللغة الأساسية: {lang} · اليوم {day} من {total}",
    dayStreak: "يوم متواصل",
    share: "مشاركة",
    wordsLearned: "الكلمات المتعلمة",
    lessonsDone: "الدروس المنجزة",
    goalComplete: "الهدف المنجز",
    timeStudied: "وقت الدراسة",
    hoursUnit: "ساعة",
    paceTitle: "📊 متتبع الوتيرة اليومية",
    statusAhead: "🚀 {delta} كلمة متقدم!",
    statusBehind: "⚡ {delta} كلمة للتعويض",
    statusOnTrack: "✅ في المسار الصحيح!",
    paceTarget: "الهدف: {wpd} كلمة/يوم · اليوم: {today} كلمة",
    paceExpected: "المتوقع: {n}",
    paceGoal: "الهدف: {n}",
    actionCurrentLesson: "الدرس الحالي",
    actionAllLessons: "جميع الدروس",
    actionFlashcards: "البطاقات التعليمية",
    actionProgress: "تقدمي",
    actionGoals: "أهدافي",
    actionMyVocabulary: "مفرداتي",
    actionGrammarLab: "مختبر القواعد",
    actionListenSpeak: "مختبر الاستماع والتحدث",
    lessonsSub: "{count} موضوع · {words} كلمة",
    cardsDue: "{n} بطاقات مستحقة اليوم!",
    allCaughtUp: "انتهيت من الكل! 🎉",
    progressSub: "الرسوم البيانية، الدقة، نمو المفردات",
    myVocabSub: "تصفح كل الكلمات التي تعلمتها",
    listenSpeakSub: "تدرّب على التحدث مع بابي",
    goalsSub: "{words} كلمة · {days} يوم",
    apiCost: "💰 متتبع تكلفة API",
    since: "منذ {date}",
    resetBtn: "↺ إعادة تعيين",
    totalTokens: "إجمالي الرموز",
    inputTokens: "الإدخال",
    outputTokens: "الإخراج",
    estCost: "التكلفة التقديرية",
    apiNote: "claude-sonnet-5 · $3/MTok in · $15/MTok out",
    tipLabel: "نصيحة:",
    tips: [
      "في التركية، يأتي الفعل دائماً في نهاية الجملة — «Ben kahve içiyorum» تعني «أنا أشرب القهوة.» فقط استوعب الأنماط!",
      "تستخدم التركية انسجام الحروف المتحركة — تتغير حروف المتحركة في اللواحق لتتطابق مع آخر حرف متحرك في الجذر (مثل -lar/-ler، -da/-de). بمجرد أن تلاحظه، كل شيء يصبح واضحاً!",
      "لا يوجد جنس نحوي في التركية. لا أسماء مذكرة أو مؤنثة — شيء أقل لحفظه مقارنة بالفرنسية أو الإسبانية أو الألمانية!",
      "عادةً ما تُحذف الضمائر الشخصية (ben = أنا، sen = أنت) في التركية لأن لاحقة الفعل تخبرك بالفاعل.",
      "التركية منتظمة صوتياً — كل حرف ينطق دائماً بنفس الطريقة. ما تقرأه هو بالضبط ما تقوله.",
      "النفي يتكوّن بإضافة -me/-ma مباشرة بعد جذر الفعل: gel (تعال) ← gelme (لا تأتِ)، anla (افهم) ← anlama.",
      "تستخدم التركية حروف جر تأتي بعد الاسم: «İstanbul'da» = «في إسطنبول» (إسطنبول + لاحقة المكان -da).",
      "تتبع لاحقة الجمع انسجام الحروف المتحركة: -lar بعد الحروف الخلفية (a, ı, o, u) و-ler بعد الحروف الأمامية (e, i, ö, ü). Akşam ← akşamlar، gece ← geceler.",
      "تشير اللاحقة -ıyor/-iyor/-uyor/-üyor إلى زمن المضارع المستمر. Anlıyorum = أنا أفهم الآن (anla + ıyor + um).",
      "تجمع الأفعال المركبة التركية اسماً مع etmek (يفعل) أو olmak (يكون): teşekkür etmek (يشكر)، hazır olmak (يكون جاهزاً).",
    ],
  },
  lesson: {
    backBtn: "→ رجوع",
    topicOf: "موضوع {order} من {total} · {words} كلمة",
    translating: "جارٍ تحضير الدرس…",
    newWords: "✨ كلمات جديدة ({n})",
    alreadyLearned: "🔄 تعلمت مسبقاً ({n})",
    practiceDialogue: "🎭 تدريب",
    generateDialogue: "🎭 أعطني حواراً تدريبياً",
    listenSpeakPractice: "🎧 تدرّب في مختبر الاستماع والتحدث",
    generatingDialogue: "بابي يُعدّ الحوار…",
    newDialogue: "↺ حوار جديد",
    lessonSaved: "🎉 تم حفظ الدرس! جارٍ إضافة {n} بطاقة جديدة…",
    alreadyTaken: "✅ الدرس مكتمل مسبقاً",
    markComplete: "✅ أكمل الدرس واحفظ البطاقات التعليمية",
  },
  vocab: {
    structure: "التركيب",
    loadingExample: "جارٍ التحميل…",
    limitReached: "↺ وصلت الحد",
    anotherLeft: "↺ أخرى ({n} متبقية)",
    anotherExample: "↺ مثال آخر",
    analyzing: "جارٍ التحليل…",
    analyzed: "✓ تم التحليل",
    analyzeWord: "🔍 تحليل الكلمة",
    analysisIntro: "إليك التحليل النحوي خطوة بخطوة:",
    analysisError: "تعذّر تحميل التحليل. يرجى المحاولة مجدداً.",
    reportMistake: "🚩 الإبلاغ عن خطأ",
    reportWrongMeaning: "معنى الكلمة خاطئ",
    reportWrongSentence: "معنى الجملة خاطئ",
    reportOther: "أخرى",
    reportChecking: "جارٍ التحقق…",
    reportThanks: "✓ شكرًا لمساعدتك في التحسين!",
    reportNoIssue: [
      "لم أجد أي مشكلة هنا — هذا يبدو صحيحًا بالنسبة لي!",
      "لا أرى أي مشاكل هنا — هذا يبدو صحيحًا.",
      "يبدو كل شيء على ما يرام من وجهة نظري.",
      "لم أتمكن من تحديد أي مشاكل؛ هذا يبدو صحيحًا كما هو مكتوب.",
      "هذا يبدو جيدًا بالنسبة لي — ليس لدي أي مخاوف.",
      "راجعتُ الأمر ولم أجد ما يحتاج إلى تغيير.",
      "لم تلفت أي مشكلة انتباهي؛ تبدو الترجمة صحيحة.",
      "بقدر ما أستطيع أن أرى، كل شيء صحيح.",
      "لم أتمكن من رصد أي مشاكل؛ هذا يبدو جيدًا بالنسبة لي.",
    ],
    reportCheckError: "واجهت مشكلة في إتمام الفحص. يرجى المحاولة مرة أخرى لاحقًا.",
    reportOkBtn: "حسنًا، فهمت",
    reportEscalateBtn: "التصعيد إلى مراجع بشري",
    reportEscalatedMsg: "✓ تم الإرسال إلى فريق المراجعة لدينا. شكرًا لك!",
    reportAlreadyFlaggedMsg: "✓ تم بالفعل الإبلاغ عن هذا إلى فريق المراجعة لدينا. شكرًا لك!",
  },
  allLessons: {
    title: "📚 جميع الدروس",
    subtitle: "{count} موضوع · {words} كلمة",
    searchPlaceholder: "🔍 ابحث في الموضوعات أو الكلمات…",
    noResults: "لا توجد موضوعات تطابق \"{search}\"",
    overwhelmedBanner: "لديك {n} بطاقة للمراجعة. يرجى مراجعة بطاقاتك قبل البدء في دروس جديدة.",
    overwhelmedLock: "راجع البطاقات أولاً",
    overwhelmedBtn: "الانتقال إلى البطاقات التعليمية →",
  },
  flashcards: {
    title: "البطاقات التعليمية",
    cardOf: "البطاقة {current} من {total}",
    tapToReveal: "اضغط للكشف",
    hearIt: "🔊 استمع",
    hearSentence: "🔊 استمع إلى الجملة.",
    allConsolidated: "كل شيء راسخ",
    noDue: "لا توجد بطاقات مستحقة الآن.\nذاكرتك مرتاحة جيداً.",
    backToDashboard: "العودة للوحة التحكم",
    sessionComplete: "اكتملت الجلسة",
    memoryRetention: "كفاءة الذاكرة",
    forgotten: "نسيت",
    struggled: "صعب",
    recalled: "تذكرت",
    effortless: "سهل جداً",
    wordsConsolidated: "{retained} من {total} كلمة راسخة",
    wordsInProgress: "{retained} من {total} كلمة قيد الترسيخ",
    saveContinue: "حفظ ومتابعة",
    tomorrow: "غداً",
    nDays: "{n} يوم",
    d1Title: "الفهم",
    d1SubSkill: "لتحسين مهارات القراءة والاستماع",
    d1Journey: "تبدأ الكلمات الجديدة رحلتها من هنا.",
    d1Due: "{n} للمراجعة",
    d1Listen: "استمع",
    d1ShowWord: "أظهر الكلمة",
    d2Title: "الإنتاج",
    d2SubSkill: "لتحسين مهارات الكلام والكتابة",
    d2WillStart: "سيبدأ لاحقاً",
    d2Empty: "تصل الكلمات هنا بعد إتقانها في مجموعة بطاقات الفهم.",
    d2ModalTitle: "تم فتح ممارسة الإنتاج!",
    d2ModalBody: "هذه كلمات تتعرف عليها جيداً. الآن ندربك على إنتاجها — هكذا تنتقل من فهم {targetLang} إلى التحدث بها.",
    d2ModalBtn: "فهمت",
    leaveConfirmTitle: "تقدم مراجعة غير محفوظ",
    leaveConfirmBody: "لقد راجعت بطاقات في هذه الجلسة لم يتم حفظها بعد. إذا غادرت الآن دون الحفظ، سيضيع هذا التقدم.",
    leaveConfirmSave: "حفظ ومغادرة",
    leaveConfirmDiscard: "تجاهل ومغادرة",
    leaveConfirmCancel: "إلغاء",
    faq: {
      whyTwoQ: "لماذا رزمتان؟",
      whyLaterQ: "لماذا تبدأ مجموعة بطاقات الإنتاج لاحقاً؟",
      whyReturnQ: "لماذا تعود البطاقات باستمرار؟",
    },
  },
  grammarLab: {
    title: "📘 مختبر القواعد",
    subtitle: "{count} نقطة قواعد للاستكشاف",
    backBtn: "← رجوع",
    searchPlaceholder: "🔍 البحث عن نقاط القواعد…",
    noResults: "لا توجد نقاط قواعد تطابق \"{search}\"",
    allCategories: "جميع الفئات",
    allLevels: "جميع المستويات",
    notReviewedLabel: "لم تتم المراجعة",
    reviewedLabel: "تمت المراجعة",
    dueBadge: "{n} بانتظار المراجعة",
    explanationLabel: "الشرح",
    seeReference: "(انظر {term})",
    ruleLabel: "القاعدة",
    formsLabel: "الصيغ",
    translatingNote: "جارٍ الترجمة إلى العربية...",
    practiceBtn: "▶ تدرّب على هذه النقطة",
    detailedExplanationBtn: "📖 شرح مفصّل",
    practiceTitle: "تدريب",
    practiceQuestion: "كيف تقول هذا بالتركية؟",
    practiceOf: "{current} من {total}",
    practiceCorrectFeedback: "صحيح!",
    practiceIncorrectFeedback: "ليس تماماً — الإجابة الصحيحة كانت {answer}.",
    practiceNext: "التالي →",
    practiceDone: "اكتمل التدريب",
    practiceScore: "{correct} من {total} صحيحة",
    practiceNextReview: "المراجعة القادمة خلال {days} يوم",
    practiceReset: "ليس هذه المرة — ستشاهد هذه النقطة مرة أخرى غداً.",
    practiceAgainBtn: "تدرّب مرة أخرى",
    practiceCloseBtn: "تم",
    categories: {
      existential: "الوجود",
      noun_suffix: "لاحقة اسمية",
      case_suffix: "لاحقة الحالة الإعرابية",
      verb_conjugation: "تصريف الفعل",
      question_particle: "أداة الاستفهام",
      copula: "الفعل الرابط",
      modal_construction: "تركيب وجهي",
    },
    points: {
      GP0001: { title: "الوجود والتوفر: var / yok", ruleSummary: "[مكان/مالك] + [شيء] + var / yok" },
      GP0002: { title: "لاحقة الجمع: -ler / -lar", ruleSummary: "اسم + -ler (أمامي) / -lar (خلفي)" },
      GP0003: { title: "حالة المكان: -de / -da / -te / -ta", ruleSummary: "اسم + -de/-da؛ -te/-ta بعد حرف ساكن مهموس" },
      GP0004: { title: "حالة الجهة: -e / -a", ruleSummary: "اسم + -e/-a؛ تُدرج -y- وصل بعد حرف متحرك" },
      GP0005: { title: "حالة الابتداء: -den / -dan / -ten / -tan", ruleSummary: "اسم + -den/-dan؛ -ten/-tan بعد حرف ساكن مهموس" },
      GP0006: { title: "حالة المفعول به المحدد: -i / -ı / -u / -ü", ruleSummary: "اسم + -i/-ı/-u/-ü؛ -y- وصل بعد حرف متحرك" },
      GP0007: { title: "المضارع المستمر — المثبت: -iyor", ruleSummary: "جذر الفعل + -iyor + لاحقة الضمير" },
      GP0008: { title: "المضارع المستمر — المنفي: -mıyor / -miyor / -muyor / -müyor", ruleSummary: "جذر الفعل + -mıyor/-miyor/-muyor/-müyor + لاحقة الضمير" },
      GP0009: { title: "المضارع المستمر — الاستفهام: -iyor mu", ruleSummary: "الجذر + -iyor + mu(+الضمير)؛ onlar: الجذر + -iyorlar + mı" },
      GP0010: { title: "أداة الاستفهام بنعم/لا: mı / mi / mu / mü", ruleSummary: "[كلمة] + أداة منفصلة mı/mi/mu/mü ?" },
      GP0011: { title: "الماضي البسيط: -di / -dı / -du / -dü / -ti / -tı / -tu / -tü", ruleSummary: "جذر الفعل + -di/-dı/-du/-dü (أو -ti/... بعد مهموس) + لاحقة الضمير" },
      GP0012: { title: "لواحق الفعل الرابط (المضارع): -(y)ım, -sin, -ø, -(y)ız, -siniz", ruleSummary: "الخبر + -(y)ım / -sin / -ø / -(y)ız / -siniz / (-lar)" },
      GP0013: { title: "لواحق الملكية: لي / لك / له-لها / لنا / لكم / لهم", ruleSummary: "(benim/senin/...) اسم + -im/-in/-i/-imiz/-iniz/-leri" },
      GP0014: { title: "التعبير عن الرغبة: -mek / -mak istemek", ruleSummary: "[المصدر -mek/-mak] + istemek (مُصرَّف)" },
      GP0015: { title: "طلب مؤدب / صيغة الأمر لجمع المخاطب: -in / -iniz", ruleSummary: "جذر الفعل + -in/-ın/-un/-ün (مؤدب) أو -iniz (أكثر رسمية)؛ -y- وصل بعد حرف متحرك" },
    },
  },
  placementTest: {
    title: "🎯 اختبار تحديد المستوى",
    offerTitle: "هل تعرف بعض التركية بالفعل؟",
    offerBody: "أجرِ اختبار تحديد مستوى سريعًا — نحو 20 سؤالًا — لمعرفة نقطة انطلاقك. سنُعدّل درسك الحالي وفقًا لذلك، لكن جميع المواضيع تبقى مفتوحة للتصفح.",
    startBtn: "ابدأ الاختبار",
    notNowBtn: "ليس الآن",
    roundLabel: "الجولة {round} من {totalRounds}",
    questionLabel: "السؤال {n} من {total}",
    wordPrompt: "ما معنى هذه الكلمة؟",
    listeningPrompt: "استمع واختر الكلمة التي سمعتها",
    listeningReplay: "إعادة التشغيل",
    preparingRound: "جارٍ تحضير أسئلتك…",
    finishBtn: "عرض نتيجتي",
    resultsTitle: "نتيجة تحديد مستواك",
    resultsLevel: "تم تحديد مستواك عند {level}",
    resultsBody: "يبدأ درسك الحالي الآن من هذا المستوى. يمكنك دائمًا تصفح أي موضوع سابق أو لاحق من كل الدروس.",
    continueBtn: "متابعة",
  },
  goals: {
    title: "🎯 أهدافي",
    displayName: "اسم العرض",
    namePlaceholder: "اسمك…",
    vocabTarget: "هدف المفردات",
    words: "كلمة",
    minWords: "الحد الأدنى 1,500",
    midWords: "2,000",
    maxWords: "الحد الأقصى 3,500",
    courseDuration: "مدة الدورة المستهدفة",
    months: "أشهر",
    month: "شهر",
    monthsPlural: "أشهر",
    daysSummary: "= {days} يوم",
    baseLanguage: "اللغة الأساسية",
    otherLanguage: "لغات أخرى (قريبًا)",
    selectLanguage: "اختر لغة…",
    ok: "موافق",
    langNames: {
      English: "الإنجليزية", Farsi: "الفارسية", Arabic: "العربية",
      French: "الفرنسية", German: "الألمانية", Spanish: "الإسبانية",
      Russian: "الروسية", Portuguese: "البرتغالية", Chinese: "الصينية",
      Turkish: "التركية", Hindi: "الهندية", Italian: "الإيطالية",
    },
    targetLanguage: "اللغة المستهدفة",
    targetLangNames: {
      Turkish: "التركية",
    },
    wordsLbl: "كلمة",
    wordsPerDay: "كلمة/يوم",
    daysLbl: "يوم",
    saved: "✅ تم حفظ الأهداف!",
  },
  progress: {
    title: "📈 تقدمي",
    memDistTitle: "توزيع حالة الذاكرة · {n} بطاقة",
    inAcquisition: "قيد الاكتساب",
    rooted: "راسخ",
    fluent: "طليق",
    deeplyRetained: "محفور في الذاكرة",
    acqDesc: "ثبات أقل من 3 أيام",
    rootedDesc: "ثبات 3–21 يوماً",
    fluentDesc: "ثبات 21–90 يوماً",
    retainedDesc: "ثبات أكثر من 90 يوماً",
    forecastTitle: "توقعات المراجعة — 15 يوماً القادمة",
    cardsDue: "بطاقات مستحقة",
    today: "اليوم",
    tmrw: "غداً",
    plusDays: "+{n}ي",
    todayFull: "اليوم",
    tmrwFull: "غداً",
    plusDaysFull: "+{n} أيام",
    goalProgress: "التقدم العام نحو الهدف",
    wordsLearned: "{learned} / {target} كلمة تعلمتها",
    vocabGrowth: "نمو المفردات",
    noChart: "أكمل درسك الأول لترى الرسم البياني! 📚",
    wordsLearnedSeries: "الكلمات المتعلمة",
    topicRings: "حلقات ذاكرة الموضوعات",
    quickStats: "إحصائيات سريعة",
    dayStreak: "يوم متواصل 🔥",
    lessonsDone: "درساً منجزاً",
    totalStudy: "إجمالي الدراسة",
    avg14Day: "متوسط 14 يومًا",
    minUnit: "دقيقة",
    dayLabel: "اليوم {n}",
    cards: "بطاقات",
  },
  myVocab: {
    title: "📝 مفرداتي",
    summaryTitle: "{n} كلمة تمت مواجهتها",
    searchPlaceholder: "🔍 ابحث في كلماتك…",
    allStatuses: "كل الحالات",
    noResults: "لا توجد كلمات تطابق \"{search}\"",
    noWords: "أكمل درسًا لتبدأ ببناء مفرداتك! 📚",
    completedTopicsTitle: "المواضيع المكتملة ({n} من {total})",
    noDate: "—",
  },
  badges: {
    newbie: "المستجد",
    wordExplorer: "مستكشف الكلمات",
    wordNerd: "مهووس بالكلمات",
    wordWizard: "ساحر الكلمات",
    rockstar: "نجم الروك",
    expert: "خبير",
    champion: "بطل",
  },
  memStates: {
    inAcquisition: "قيد الاكتساب",
    rooted: "راسخ",
    fluent: "طليق",
    deeplyRetained: "محفور في الذاكرة",
  },
  chat: {
    subtitle: "معلمك التركي",
    greetWords: ["مرحباً", "أهلاً", "أهلاً وسهلاً"],
    greeting: "{greet} {name}،\n\nاسألني أي شيء عن اللغة التركية — قواعد، مفردات، ثقافة — أو عن كيفية استخدام هذا التطبيق.",
    placeholder: "اسأل عن التركية أو التطبيق…",
    error: "عذراً، لم أستطع الاتصال الآن. يرجى المحاولة مرة أخرى.",
    escalationFallback: "أعتذر، لم أتمكن من مساعدتك بالكامل في ذلك. لقد أبلغت فريقنا بذلك، وستتلقى ردًا عبر البريد الإلكتروني — عادةً خلال يومي عمل. يمكنك أيضًا التواصل معنا مباشرة على support@speafy.com.",
    welcome: "مرحباً، {name}! 👋 أهلاً بك في Speafy! أنا بابي، وأنا هنا من أجل أمرين: مساعدتك على التعرّف على التطبيق، والإجابة عن أي أسئلة لديك حول {targetLanguage}.\n\nابدأ بالدرس الحالي، أو اختر موضوعاً من «جميع الدروس». لا تنسَ تحديد كل درس كمكتمل عند الانتهاء منه، ثم مراجعة البطاقات التعليمية بعد ذلك.\n\nاسألني في أي وقت — عن التطبيق أو عن {targetLanguage}.\n\nحظاً موفقاً في رحلة تعلمك! 😊",
    lessonLimit: "لقد أتممت {limit} دروس اليوم — رائع جداً! 🌟\n\nللحفاظ على استدامة تعلمك ومنع تراكم البطاقات التعليمية، هناك حد يومي يبلغ {limit} دروس.\n\nأعطِ عقلك بعض الوقت لترسيخ ما تعلمته اليوم. لماذا لا تجرب جلسة مراجعة للبطاقات التعليمية بدلاً من ذلك؟\n\nسأكون هنا غداً لمزيد من الدروس! 😊",
    streakDecayed: "مرحبًا بعودتك! 👋 لقد غبت لمدة {days} يوم. بفضل {protection} من أيام حماية السلسلة 🛡️ التي اكتسبتها، انخفضت سلسلتك فقط من {oldStreak} إلى {newStreak} بدلاً من أن تختفي تمامًا. لنواصل البناء!",
    streakWiped: "مرحبًا بعودتك! 👋 لقد غبت لمدة {days} يوم — أكثر من {protection} من أيام حماية السلسلة 🛡️ التي كنت قد جمعتها، لذا بدأت سلسلتك من جديد عند 1. كل سلسلة تبدأ من مكان ما — لنعد بناءها!",
    weeklyRecapFallback: "مرحبًا! 👋 كنت أريد تقديم ملخصك الأسبوعي، لكنني أواجه مشكلة في إعداده الآن. لكن بسرعة — أنت في سلسلة {streak} يوم، واصل التقدم! 🔥",
    dailyPlanQuestion1: "مرحبًا! 👋 كم من الوقت لديك للدراسة اليوم؟",
    dailyPlanQuestion2: "أهلاً! 😊 لدي خطة دراسة لك — كم دقيقة يمكنك تخصيصها اليوم؟",
    dailyPlanQuestion3: "مستعد لخطة اليوم؟ 🎯 فقط أخبرني تقريبًا كم من الوقت لديك.",
    dailyPlanClarify: "آسف، لم أفهم ذلك جيدًا! هل يمكنك إعطائي رقمًا تقريبيًا، مثل '20' أو '30 دقيقة'؟",
    dailyPlanUnreasonable: "هذا لا يبدو وكأنه جلسة دراسة معتادة! هل يمكنك إعطائي رقمًا بين 5 دقائق وحوالي 5 ساعات؟",
    dailyPlanGiveUp: "لا بأس — عندما تكون مستعدًا، توجه فقط إلى البطاقات التعليمية أو درسك الحالي وابدأ! 😊",
    dailyPlanFallback: "لقد سجلت وقتك المتاح، لكنني أواجه مشكلة في إعداد خطة اليوم الآن. في هذه الأثناء، البطاقات التعليمية دائمًا خيار آمن إذا كان لديك بطاقات مستحقة! 😊",
    sendBtn: "إرسال",
    askBabi: "اسأل بابي",
    voiceConsentTitle: "تفعيل الدردشة الصوتية مع بابي؟",
    voiceConsentBody: "سيستخدم بابي الميكروفون للاستماع إليك ومكبر الصوت للرد عليك. يتم تحويل كلامك إلى نص — ولا يتم الاحتفاظ بالتسجيل الصوتي نفسه أبدًا. يمكن الاحتفاظ بالنص لمدة تصل إلى 30 يومًا. راجع سياسة الخصوصية لمزيد من التفاصيل.",
    voiceConsentPrivacyLink: "سياسة الخصوصية",
    voiceConsentAllow: "السماح باستخدام الميكروفون",
    voiceConsentDecline: "ليس الآن",
    voiceDenied: "الدردشة الصوتية غير متاحة بدون إذن الوصول إلى الميكروفون. يمكنك متابعة الدردشة بالكتابة — اضغط على أيقونة الميكروفون في أي وقت لإعادة المحاولة.",
    voiceDeviceInUse: "يبدو أن الميكروفون قيد الاستخدام في مكان آخر — أغلق التطبيقات الأخرى التي تستخدمه وحاول مرة أخرى.",
    voiceError: "حدث خطأ ما في الدردشة الصوتية. يرجى المحاولة مرة أخرى.",
    voiceStarting: "جارٍ البدء… يرجى الانتظار",
    voiceListening: "أستمع…",
    voiceProcessing: "أفهم…",
    voiceReviewHint: "اضغط للتعديل، أو سيتم الإرسال تلقائيًا خلال ثوانٍ قليلة.",
    voiceSendNow: "إرسال الآن",
    voiceDiscard: "تجاهل",
    voiceEditTranscript: "تعديل ما سمعته بابي",
    voiceBadgeLabel: "أُرسلت بالصوت",
    voiceDidntCatch: "لم أفهم ذلك — اضغط على الميكروفون للمحاولة مرة أخرى.",
    voiceSpeaking: "بابي تتحدث…",
    voiceTtsUnavailable: "الصوت غير متاح لهذا الرد — سيتم عرض النص بدلاً من ذلك.",
    voiceTtsUnavailableLanguage: "رد بابي الصوتي غير متاح بعد باللغة {language}.",
    voiceTapToHear: "اضغط لسماع رد بابي",
    voiceNotEntitled: "الدردشة الصوتية مع بابي ميزة مميزة — قم بالترقية لاستخدامها.",
    voiceNoBalance: "لقد استخدمت كل دقائق الصوت لهذه الدورة. ستتجدد في الدورة القادمة.",
    voiceOtherTabActive: "الدردشة الصوتية نشطة بالفعل في علامة تبويب أخرى.",
    voiceLowBalanceNudge: "دقائق الصوت لهذه الدورة أوشكت على النفاد.",
    voiceLowMinutesHeadsUp: "دقائق الصوت لهذه الدورة أوشكت على النفاد.",
    voiceGetMoreMinutes: "احصل على المزيد من الدقائق",
    voiceStopBtn: "إيقاف",
    voiceMicButtonLabel: "الدردشة الصوتية",
    voiceBannerDismiss: "إغلاق",
  },
  settings: {
    title: "الإعدادات",
    accountSection: "الحساب",
    linkedGoogle: "مرتبط بـ Google",
    emailAccountBadge: "حساب بريد إلكتروني",
    changeNameBtn: "تغيير اسم المستخدم",
    nameSaveBtn: "حفظ",
    nameCancelBtn: "إلغاء",
    nameSaving: "جارٍ الحفظ…",
    passwordLabel: "كلمة المرور",
    passwordSub: "إرسال رابط إعادة تعيين إلى بريدك الإلكتروني",
    passwordSent: "تم الإرسال ✓",
    passwordResetBtn: "إعادة تعيين",
    subscriptionSection: "الاشتراك",
    subscriptionAdminLabel: "حساب المشرف",
    subscriptionAdminSub: "لديك وصول كامل ودائم إلى جميع الميزات.",
    subscriptionReviewerLabel: "وصول المُراجع",
    subscriptionReviewerSub: "لديك وصول مجاني إلى جميع الميزات بصفتك مُراجعًا للتطبيق.",
    subscriptionProPlan: "Speafy Pro — {plan}",
    subscriptionElitePlan: "Speafy Elite — {plan}",
    subscriptionPlanAnnual: "سنوي",
    subscriptionPlanMonthly: "شهري",
    subscriptionRenews: "يتجدد في {date}",
    subscriptionActive: "نشط",
    subscriptionManageLink: "الفوترة والفواتير",
    subscriptionCancelLink: "إلغاء الاشتراك أو إيقافه مؤقتًا",
    subscriptionPaymentFailedLabel: "فشلت آخر عملية دفع",
    subscriptionPaymentFailedSub: "فشل الدفع في {date}",
    subscriptionPaymentFailedSubNoDate: "يرجى تحديث طريقة الدفع للحفاظ على وصولك إلى Pro",
    subscriptionUpdatePaymentLink: "تحديث طريقة الدفع ↗",
    subscriptionCancelledPending: "تنتهي خطتك في {date} — ستحتفظ بوصول Pro حتى ذلك الحين",
    subscriptionPausedLabel: "الاشتراك متوقف مؤقتًا",
    subscriptionPausedSub: "يُستأنف تلقائيًا في {date} — سيتم تحصيل رسوم كاملة لفترة جديدة ما لم تستأنفه مبكرًا",
    subscriptionPausedSubNoDate: "يُستأنف تلقائيًا بعد 3 أشهر ما لم تستأنفه مبكرًا",
    subscriptionResumeBtn: "استأنف الآن",
    subscriptionResuming: "جارٍ الاستئناف…",
    pausePendingLabel: "الإيقاف المؤقت مجدول",
    pausePendingSub: "يسري في {date}، في نهاية فترة الفوترة الحالية",
    manageOfferTitle: "هل تفكر في الإلغاء؟",
    manageOfferSub: "أوقف الاشتراك مؤقتًا بدلاً من ذلك — ستحتفظ بتقدمك حتى {date}، ثم يُستأنف تلقائيًا بعد 3 أشهر وتُحصَّل رسوم كاملة لفترة جديدة، ما لم تستأنفه مبكرًا.",
    manageOfferPauseBtn: "إيقاف مؤقت بدلاً من ذلك",
    manageOfferContinueLink: "الإلغاء على أي حال",
    manageOfferDismiss: "تراجع",
    pauseOfferLabel: "بحاجة إلى استراحة؟",
    pauseOfferSub: "أوقف اشتراكك مؤقتًا لمدة 3 أشهر بدلاً من إلغائه — احتفظ بتقدمك، واستأنفه في أي وقت.",
    pauseOfferBtn: "إيقاف الاشتراك مؤقتًا",
    pauseConfirmP1: "هل تريد إيقاف اشتراكك في Speafy Pro مؤقتًا؟",
    pauseConfirmC1: "تستمر فترة الفوترة الحالية حتى {date} — تحتفظ بكل ما دفعته بالفعل.",
    pauseConfirmC2: "أثناء الإيقاف المؤقت، تُقفل الدروس الجديدة (كما في خطة مجانية منتهية)، لكن يمكنك متابعة مراجعة بطاقاتك الحالية بشكل طبيعي.",
    pauseConfirmC3: "يستمر الإيقاف المؤقت لمدة 3 أشهر ثابتة. إذا لم تستأنفه يدويًا قبل ذلك، سيُستأنف تلقائيًا وتُحصَّل رسوم كاملة لفترة جديدة.",
    pauseConfirmBtn: "تأكيد الإيقاف المؤقت",
    pausing: "جارٍ الإيقاف المؤقت…",
    pauseFailedGeneric: "حدث خطأ ما أثناء إيقاف اشتراكك مؤقتًا. يرجى المحاولة مرة أخرى أو التواصل مع الدعم.",
    manageLinkLoading: "جارٍ التحميل…",
    manageLinkFailedGeneric: "تعذّر تحميل رابط الإدارة الآن. يرجى المحاولة مرة أخرى.",
    resumeConfirmP1: "هل تريد استئناف اشتراكك في Speafy Pro الآن؟",
    resumeConfirmC1: "سيتم تحصيل رسوم كاملة لفترة فوترة جديدة على الفور.",
    resumeConfirmBtn: "نعم، استأنف الآن",
    resumeFailedGeneric: "حدث خطأ ما أثناء استئناف اشتراكك. يرجى المحاولة مرة أخرى أو التواصل مع الدعم.",
    subscriptionLastCharge: "آخر رسوم: {amount} في {date} — {status}",
    subscriptionLastChargePaid: "مدفوع",
    subscriptionLastChargeFailed: "فشل",
    tierChangePendingLabel: "تغيير الخطة مجدوَل",
    tierChangePendingToElite: "التبديل إلى Elite في {date}",
    tierChangePendingToBasic: "التبديل إلى Pro في {date}، في نهاية دورة الفوترة الحالية",
    tierUpgradeToEliteLink: "الترقية إلى Elite",
    tierDowngradeToBasicLink: "العودة إلى Pro",
    tierUpgradeConfirmTitle: "الترقية إلى Elite؟",
    tierUpgradeConfirmSub: "سيتم تحصيل الفرق النسبي منك اليوم، وستحصل فورًا على 3 ساعات من محادثة Elite الصوتية مع بابي — {price}/{interval} بعد ذلك.",
    tierDowngradeConfirmTitle: "العودة إلى Pro؟",
    tierDowngradeConfirmSub: "ستحتفظ بـ Elite حتى {date}، ثم ستنتقل إلى Pro في تاريخ الفوترة التالي — بدون رسوم اليوم.",
    tierUpgradeConfirmBtn: "نعم، رقّي الآن",
    tierDowngradeConfirmBtn: "نعم، العودة إلى Pro",
    tierChangeBusy: "جارٍ التحديث…",
    tierChangeFailedGeneric: "حدث خطأ ما أثناء تغيير خطتك. يرجى المحاولة مرة أخرى أو التواصل مع الدعم.",
    voiceMinutesLabel: "دقائق الصوت ({tier})",
    voiceTierElite: "Elite",
    voiceTierBasic: "Pro",
    voiceTierTrial: "تجريبي",
    voiceTierAdmin: "مشرف",
    voiceTierViewer: "مُطّلِع",
    voiceMinutesUsed: "تم استخدام {used} من {limit} في هذه الدورة",
    voiceMinutesPurchasedExtra: "بالإضافة إلى {extra} مشتراة — تُستخدم بعد نفاد دقائقك الشهرية ولا تنتهي صلاحيتها أبدًا",
    yourDataSection: "بياناتك",
    marketingLabel: "الموافقة على الاتصالات التسويقية",
    marketingSub: "التحديثات والإشعارات والعروض الخاصة",
    voiceConsentLabel: "الدردشة الصوتية مع بابي",
    voiceConsentSub: "السماح لبابي بسماعك والرد بصوت مسموع",
    privacyLegalSection: "الخصوصية والشروط والقانونية",
    privacyPolicyLabel: "سياسة الخصوصية",
    privacyPolicySub: "كيف نجمع بياناتك ونستخدمها ونحميها",
    viewLink: "عرض",
    termsLabel: "شروط الخدمة",
    termsSub: "القواعد والشروط التي تحكم استخدامك",
    refundLabel: "سياسة الاسترداد",
    refundSub: "الأهلية وكيفية طلب استرداد الأموال",
    cookieSettingsLabel: "إعدادات ملفات تعريف الارتباط",
    cookieSettingsSub: "إدارة ملفات تعريف الارتباط التحليلية والوظيفية",
    manageLink: "إدارة",
    privacySection: "الخصوصية والبيانات",
    exportLabel: "تصدير بياناتي",
    exportSub: "تنزيل ملف JSON من ملفك الشخصي وتقدمك وبطاقاتك التعليمية",
    exportBtn: "تصدير",
    exportDone: "✓ تم التنزيل",
    cacheLabel: "ذاكرة التخزين المؤقت المحلية",
    cacheSub: "يتم تخزين تقدم التعلم وجمل الأمثلة في متصفحك للسرعة.",
    cookieLabel: "إعدادات ملفات تعريف الارتباط والخصوصية",
    cookieSub: "يتم إدارة تفضيلات التحليلات وملفات تعريف الارتباط على موقع Speafy",
    privacyLink: "سياسة الخصوصية ↗",
    aboutSection: "حول",
    aiTutorLabel: "المدرس الذكي",
    aiTutorSub: "مدعوم بـ Claude Sonnet — Anthropic",
    algoLabel: "خوارزمية الذاكرة",
    algoSub: "FSRS v4.5 — جدولة التكرار المتباعد المجانية",
    learningSection: "التعلّم",
    placementTestLabel: "اختبار تحديد المستوى",
    placementTestSubNew: "اكتشف مستواك المبدئي عبر اختبار سريع",
    placementTestSubRetake: "آخر تحديد: {level} · يمكنك إعادته في أي وقت",
    placementTestBtnNew: "إجراء الاختبار",
    placementTestBtnRetake: "إعادة الاختبار",
    versionLabel: "الإصدار",
    appearanceSection: "المظهر",
    darkModeLabel: "الوضع المظلم",
    darkModeSub: "التبديل إلى نظام ألوان داكن",
    largeTextLabel: "النص الكبير",
    largeTextSub: "زيادة حجم النص لسهولة القراءة",
    babiCheckinsSection: "تسجيلات وصول بابي",
    babiDailyNudgeLabel: "تذكير بابي اليومي",
    babiDailyNudgeSub: "بابي يسألك كم من الوقت لديك ويقترح خطة دراسة كل يوم",
    babiWeeklyReportLabel: "تقرير بابي الأسبوعي",
    babiWeeklyReportSub: "ملخص أسبوعي لتقدمك، مرة واحدة في الأسبوع",
    dangerSection: "منطقة الخطر",
    resetLabel: "إعادة تعيين كل التقدم",
    resetSub: "يمسح سلسلتك وبطاقاتك التعليمية وسجل الدروس. لا يمكن التراجع عنه.",
    resetBtn: "إعادة تعيين",
    resetConfirmP1: "إعادة تعيين كل التقدم؟ سيتم حذف ما يلي نهائياً:",
    resetConfirmC1: "جميع {n} بطاقات تعليمية وبيانات ذاكرتها",
    resetConfirmC2: "سلسلتك ({n} أيام) وسجل الدراسة",
    resetConfirmC3: "جميع سجلات إتمام الدروس، في كل لغة تتعلمها",
    resetConfirmC4: "تقدمك في مراجعة مختبر القواعد",
    resetConfirmP2: "سيتم الاحتفاظ بحسابك واسمك وإعدادات اللغة.",
    resetConfirmBtn: "نعم، إعادة تعيين كل شيء",
    resetting: "جارٍ إعادة التعيين…",
    resetDone: "✅ تمت إعادة تعيين التقدم! ابدأ من جديد.",
    deleteLabel: "حذف الحساب",
    deleteSub: "يحذف حسابك وجميع بياناتك بشكل دائم. لا يمكن التراجع عنه.",
    deleteBtn: "حذف الحساب",
    deleteConfirmP1: "حذف حساب Speafy نهائياً؟ سيتم حذف ما يلي فوراً وبشكل لا رجعة فيه:",
    deleteConfirmC1: "ملفك الشخصي (الاسم واللغة والأهداف)",
    deleteConfirmC2: "جميع {n} بطاقة تعليمية وبيانات الذاكرة",
    deleteConfirmC3: "سجل التعلم الكامل والسلسلة",
    deleteConfirmC4: "حساب مصادقة Firebase",
    deleteConfirmPrompt: "اكتب DELETE (بالأحرف الكبيرة) للتأكيد:",
    deleteConfirmBtn: "حذف حسابي نهائياً",
    deleting: "جارٍ الحذف…",
    cancelBtn: "إلغاء",
  },
  trial: {
    daysLeftBadge: "⏱ {n} يوم متبقٍ",
    expiredBadge: "انتهت التجربة · ترقية ↑",
    pausedBadge: "⏸ متوقف مؤقتًا",
    proBadge: "✦ الخطة الاحترافية",
    eliteBadge: "✦ خطة Elite",
  },
  paywall: {
    back: "← رجوع",
    title: "ترقية إلى Speafy Pro",
    subTrialExpired: "انتهت فترة تجربتك المجانية. قم بالترقية لمواصلة التعلم.",
    subDefault: "افتح جميع الدروس ومراجعة بطاقات الفلاش.",
    features: [
      "جميع {count} درس مفتوحة بالكامل",
      "دردشة غير محدودة مع بابي، مدرب الذكاء الاصطناعي",
      "مراجعة بطاقات FSRS الذكية",
      "تتبع التقدم وتحليلات الذاكرة",
      "صوت أصيل لكل كلمة",
      "حوارات تدريبية",
      "واجهة متعددة اللغات",
    ],
    tierPro: "Pro",
    tierElite: "Elite",
    eliteFeatures: [
      "كل ما في Speafy Pro",
      "مختبر الاستماع والتحدث — تدرّب على التحدث مع بابي",
      "3 ساعات من المحادثة الصوتية مع بابي كل شهر",
      "اشترِ دقائق صوت إضافية في أي وقت — 3$ في الساعة",
    ],
    billingMonthly: "شهري",
    billingYearly: "سنوي",
    saveBadge: "وفّر 25%",
    pricePerMonth: "/شهر",
    priceBilledYearly: "يُدفع سنوياً",
    cta: "ابدأ Speafy Pro →",
    ctaElite: "ابدأ Speafy Elite →",
    fine: "إلغاء في أي وقت · دفع آمن عبر Paddle",
    bannerExpired: "انتهت فترة تجربتك المجانية.",
    bannerActive: "تجربة مجانية — {n} يوم متبقٍ.",
    bannerBtn: "ترقية ↑",
    settingsFreePlan: "الخطة المجانية",
    pausedTitle: "اشتراكك متوقف مؤقتًا",
    pausedSub: "استأنف اشتراكك من الإعدادات لإلغاء قفل الدروس الجديدة مرة أخرى.",
    pausedGoToSettingsBtn: "الذهاب إلى الإعدادات",
    alreadyProTitle: "أنت بالفعل Pro!",
    alreadyProSub: "اشتراكك نشط — لا حاجة للشراء مرة أخرى.",
    alreadyProGoHomeBtn: "الذهاب إلى الرئيسية",
    settingsTrialRemaining: "تجربة — {n} يوم متبقٍ",
    settingsTrialEnded: "انتهت التجربة — قم بالترقية لفتح جميع الدروس",
    settingsFreeForever: "تابع من حيث توقفت — قم بالترقية لفتح جميع الدروس",
    settingsUpgradeBtn: "ترقية",
  },
  authAction: {
    verifyingTitle: "جارٍ التحقق من بريدك الإلكتروني…",
    verifiedTitle: "تم التحقق من بريدك الإلكتروني!",
    verifiedBody: "كل شيء جاهز. تابع إلى Speafy لمواصلة التعلم.",
    continueBtn: "المتابعة إلى Speafy ←",
    verifyErrorTitle: "انتهت صلاحية هذا الرابط",
    verifyErrorBody: "رابط التحقق هذا لم يعد صالحًا. سجّل الدخول وسنرسل لك رابطًا جديدًا.",
    resendBtn: "إعادة إرسال بريد التحقق",
    resendSent: "تم الإرسال ✓",
    resendError: "تعذّرت إعادة الإرسال. يُرجى المحاولة مرة أخرى بعد قليل.",
    signInBtn: "تسجيل الدخول",
    verifyingReset: "جارٍ التحقق من رابطك…",
    resetTitle: "أعد تعيين كلمة المرور",
    resetBodyFor: "اختر كلمة مرور جديدة لـ {email}",
    newPasswordPh: "كلمة المرور الجديدة",
    confirmPasswordPh: "تأكيد كلمة المرور الجديدة",
    resetSubmitBtn: "إعادة تعيين كلمة المرور",
    resettingBtn: "جارٍ إعادة التعيين…",
    resetSuccessTitle: "تم تحديث كلمة المرور!",
    resetSuccessBody: "تم تغيير كلمة المرور الخاصة بك. سجّل الدخول بكلمة المرور الجديدة.",
    resetErrorTitle: "انتهت صلاحية هذا الرابط",
    resetErrorBody: "رابط إعادة تعيين كلمة المرور هذا لم يعد صالحًا. اطلب رابطًا جديدًا من شاشة تسجيل الدخول.",
    passwordMismatch: "كلمتا المرور غير متطابقتين.",
    passwordTooShort: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
    genericError: "حدث خطأ ما. يُرجى المحاولة مرة أخرى.",
    invalidTitle: "هذا الرابط غير صالح أو منتهي الصلاحية",
    invalidBody: "الرابط الذي اتبعته لم يعد صالحًا. يُرجى العودة إلى Speafy والمحاولة مرة أخرى.",
    backToSignIn: "العودة إلى تسجيل الدخول",
  },

  teacherDash: {
    link: "لوحة المعلم",
    title: "لوحة المعلم",
    backHome: "العودة إلى الرئيسية",
    studentBadge: "معلمك: {name}",
    intro: "كل ما تحتاجه لجلب طلابك إلى Speafy ومتابعة تقدمهم.",
    referralTitle: "رابط الإحالة الخاص بك",
    referralBody: "شارك هذا الرابط مع طلابك. أي شخص يسجّل من خلاله يُربَط بك كمعلم له.",
    copy: "نسخ الرابط",
    copied: "تم النسخ",
    studentsTitle: "طلابك",
    studentsLoading: "جارٍ تحميل طلابك…",
    studentsError: "تعذّر تحميل طلابك في الوقت الحالي.",
    retry: "إعادة المحاولة",
    studentsEmpty: "لا يوجد طلاب بعد. شارك رابط الإحالة الخاص بك — سيظهر هنا الطلاب الذين ينضمون من خلاله.",
    colName: "الطالب",
    colJoined: "تاريخ الانضمام",
    colStatus: "الاشتراك",
    colCommission: "العمولة المكتسبة",
    colGrammar: "تركيز القواعد",
    statusActive: "نشِط",
    statusTrial: "تجريبي",
    statusNone: "بلا اشتراك",
    commissionNote: "هذا ما كسبته من كل طالب إجمالًا. رصيدك المتاح للدفع موضح أدناه.",
    commissionCapReached: "انتهت فترة الـ 12 شهرًا",
    grammarNote: "تُعرض بيانات أخطاء القواعد فقط للطلاب الذين لديهم اشتراك نشط.",
    studentUnnamed: "الطالب",
    curriculumTitle: "مرجع المنهج",
    curriculumBody: "تصفّح كل الموضوعات والكلمات التي يتعلمها طلابك، بالترتيب.",
    curriculumLink: "فتح مرجع المنهج",
    profileTitle: "ملفك التعريفي كمعلم",
    profileBody: "هكذا ستظهر في دليل معلمي Speafy عند إطلاقه.",
    profileBio: "نبذة مختصرة",
    profileBioPh: "جملة أو جملتان عنك وعن طريقتك في التدريس.",
    profilePhoto: "الصورة",
    photoChoose: "اختر صورة",
    photoUploading: "جارٍ الرفع…",
    photoRemove: "إزالة",
    photoHint: "PNG أو JPG، بحد أقصى 200 كيلوبايت.",
    photoTypeErr: "يرجى اختيار صورة PNG أو JPG.",
    photoSizeErr: "حجم هذه الصورة يتجاوز 200 كيلوبايت — يرجى اختيار صورة أصغر.",
    photoUploadErr: "فشل الرفع. يرجى المحاولة مرة أخرى.",
    profileLink: "موقع إلكتروني شخصي أو رابط لوسائل التواصل الاجتماعي",
    profileLinkPh: "www.example.com",
    profileLanguages: "اللغات التي أُدرّسها",
    profileLanguagesHint: "اختر اللغات التي تُدرّسها. ستُتاح لغات أخرى عندما تضيفها Speafy كلغات للدورة.",
    profileLanguagesSoon: "قريبًا",
    save: "حفظ",
    saving: "جارٍ الحفظ…",
    saved: "تم الحفظ",
    urlError: "لا يبدو هذا كعنوان ويب. تحقّق منه أو اترك الحقل فارغًا.",
    termsStatusAccepted: "شروط شراكة المعلّم — قُبِلت في {date}",
    termsStatusPending: "شروط شراكة المعلّم — لم تُقبل بعد",
    termsVersionLabel: "الإصدار {version}",
    termsView: "عرض الشروط المقبولة",
    payoutTitle: "الدفعة",
    payoutLoading: "جارٍ تحميل حالة دفعتك…",
    payoutError: "تعذّر تحميل حالة دفعتك الآن.",
    payoutBalance: "رصيدك الحالي: {balance}",
    payoutNotEligible: "ستتمكن من طلب دفعة بمجرد أن يصل رصيدك إلى {threshold}.",
    payoutAlreadyRequested: "تم طلب الدفعة — سنتواصل معك.",
    requestPayoutBtn: "طلب دفعة",
    payoutRequestFailed: "حدث خطأ أثناء إرسال طلبك. يُرجى المحاولة مرة أخرى.",
    payoutConfirmTitle: "طلب دفعة؟",
    payoutConfirmBody: "لديك حاليًا {balance} متاحة للطلب.\n\nهذا يبدأ عملية دفع يدوية — لا يتم تحويل أي أموال تلقائيًا. سنراجع طلبك ونتواصل معك عبر البريد الإلكتروني.",
    payoutConfirmBtn: "طلب دفعة",
    payoutConfirmCancel: "إلغاء",
  },

  teacherTerms: {
    screenTitle: "شروط شراكة المعلّم",
    contents: "المحتويات",
    lastUpdatedLabel: "آخر تحديث",
    effectiveLabel: "تاريخ السريان",
    bannerTitle: "إجراء مطلوب",
    bannerBody: "يرجى قراءة شروط شراكة المعلّم وقبولها للاستمرار كشريك.",
    bannerCta: "المراجعة والقبول",
    acceptedOn: "لقد قبلت هذه الشروط في {date}.",
    acceptedVersion: "الإصدار المقبول: {version}",
    accepting: "جارٍ تسجيل قبولك…",
    acceptError: "تعذّر تسجيل قبولك الآن. يرجى المحاولة مرة أخرى.",
    draftNotice: "هذه الشروط ليست نهائية بعد. ستتمكن من قبولها بمجرد تحديد تاريخ السريان.",
  },
};

export default ar;
